<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('report.winning') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('report.winning'),
            active: true
          }
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="required">{{ $t('report.gameSetting') }}</label>
                  <a-select
                    v-model="model.game_setting_id"
                    class="ts-w-full"
                    :options="game_settings"
                  ></a-select>
                  <div
                    class="validate"
                    v-if="errors.has('game_setting_id')"
                  >{{ errors.first('game_setting_id') }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="required">{{ $t('report.date') }}</label>
                  <a-range-picker 
                    class="ts-w-full" 
                    valueFormat="DD-MM-YYYY" 
                    format="DD-MM-YYYY"
                    v-model="model.date" 
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="ts-flex ts-space-x-3 ts-justify-end">
                  <ts-button
                    color="primary"
                    outline
                    @click.prevent="onPreview"
                  >{{ $t('report.preview') }}</ts-button>
                  <ts-button color="primary" @click.prevent="onDownload">
                    <i class="fas fa-file-excel" v-if="!downloading"></i>
                    <i class="fas fa-spin fa-spinner" v-else></i>
                  </ts-button>
                </div>
              </div>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <div
              id="list"
              class="ts-w-full ts-border ts-border-gray-200 ts-p-3 ts-rounded-md ts-overflow-scroll"
            >
              <ts-table :columns="columns" :records="resources" :loading="preview_load">
                <template v-slot="{ record }">
                  <td class="ts-whitespace-no-wrap" >{{ record.result_date }}</td>
                  <td class="ts-whitespace-no-wrap" >{{ record.game_id }}</td>
                  <td class="ts-whitespace-no-wrap" >{{ record.draw_id }}</td>
                  <td class="ts-whitespace-no-wrap" >{{ record.seller_id }}</td>
                  <td class="ts-whitespace-no-wrap" >{{ record.seller_name }}</td>
                  <td class="ts-whitespace-no-wrap" >{{ record.prize_level }}</td>
                  <td class="ts-whitespace-no-wrap" >{{ record.winning_amount }}</td>
                </template>
              </ts-table>
            </div>
            <div class="d-flex justify-content-end p-15">
              <ts-pagination v-model="pagination" @navigate="onPreview"></ts-pagination>
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import * as FileDownload from 'downloadjs'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'winningReport',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      preview_load: false,
      downloading: false,
      game_settings: [],
      model: {
        game_setting_id: '',
        date: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('report/winning', ['resources', 'pagination']),
    columns() {
      return [
        { name: this.$t('report.date') },
        { name: this.$t('report.gameId') },
        { name: this.$t('report.drawId') },
        { name: this.$t('report.sellerId') },
        { name: this.$t('report.sellerName') },
        { name: this.$t('report.prizeLevel') },
        { name: this.$t('report.winningAmount') }
      ]
    }
  },
  methods: {
    ...mapActions('report/winning', ['getGameSetting', 'preview', 'store']),
    fetchData() {
      this.loading = true
      this.getGameSetting()
        .then(response => {
          this.game_settings = response.data.map(el => ({
            value: el.game_setting_id,
            label: el.game_setting
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onPreview() {
      this.errors = new Errors()
      this.preview_load = true
      this.preview({
        game_setting_id: this.model.game_setting_id,
        date_from: this.model.date[0],
        date_to: this.model.date[1]
      })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.preview_load = false
        })
    },
    onDownload() {
      this.errors = new Errors()
      this.downloading = true
      this.store(this.model)
        .then(response => {
          // console.log(response.data)
          FileDownload(response, 'winning_report.xlsx')
        })
        .catch(errorData => {
          let error = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(errorData)))
          this.errors = new Errors(errorData.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.downloading = false
        })
    }
  },
    beforeRouteLeave(to, from, next) {
    this.$store.commit('report/winning/RESET_STATE')
    next()
  }
}
</script>

<style lang="css" scoped>
#list {
  min-height: 60vh;
  max-height: 70vh;
}
</style>